import * as React from 'react';
import { StaticLoadingWrapper, IconWrapper } from './styles.js';
import { LoadingState } from '../types.js';
import { Icon } from '@doordash/design-language';

var _IconTypeMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var IconTypeMap = (_IconTypeMap = {}, _defineProperty(_IconTypeMap, LoadingState.Success, Icon.Types.CheckCircleLine), _defineProperty(_IconTypeMap, LoadingState.Error, Icon.Types.CloseCircleLine), _IconTypeMap);

var StaticLoading = function StaticLoading(_ref) {
  var color = _ref.color,
      size = _ref.size,
      state = _ref.state;

  if (state !== LoadingState.Loading && state !== LoadingState.FoodLoop) {
    return /*#__PURE__*/React.createElement(StaticLoadingWrapper, {
      size: size
    }, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Icon, {
      type: IconTypeMap[state],
      color: color,
      size: size,
      shouldAdjustSmallSizesWhitespace: true
    })));
  }

  return /*#__PURE__*/React.createElement(StaticLoadingWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement("svg", {
    width: "".concat(size, "px"),
    height: "".concat(size, "px"),
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14",
    stroke: color,
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })));
};

export { StaticLoading as default };
